function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.104.159h49.793v49.793H.104z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.915 11.873c2.477-.664 5.393 1.405 7.618 4.086-1.11 2.51-1.767 5.209-1.767 7.229a9.102 9.102 0 002.793 6.572 7.957 7.957 0 01-13.101-3.773C4.321 21.74 5.67 13.01 9.915 11.872zm24.109 11.315c0-2.008-.649-4.688-1.747-7.185 2.229-2.703 5.162-4.797 7.653-4.13 4.245 1.138 5.594 9.868 4.456 14.113a7.957 7.957 0 01-13.129 3.748 9.1 9.1 0 002.767-6.546z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.895 32.316a9.129 9.129 0 009.129-9.128c0-5.042-4.087-14.316-9.129-14.316s-9.129 9.274-9.129 14.316a9.129 9.129 0 009.13 9.128z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.112 14.993l-.101 1.175c.374.071.702.186.984.344.31.173.579.368.809.587l.084.08-.064.097-.352.535a.852.852 0 01-.196.209.468.468 0 01-.278.084.636.636 0 01-.266-.068 8.43 8.43 0 01-.278-.137 6.292 6.292 0 00-.333-.157 2.033 2.033 0 00-.234-.085l-.18 2.142c.245.078.49.162.73.253.286.108.544.248.774.42.235.174.426.393.572.653.148.266.221.594.221.982 0 .38-.063.736-.19 1.07a2.62 2.62 0 01-.556.887 2.806 2.806 0 01-.897.624 3.462 3.462 0 01-1.087.276l-.06.743a.554.554 0 01-.153.33.493.493 0 01-.376.159h-.68l.106-1.271a4.5 4.5 0 01-1.188-.366 3.751 3.751 0 01-1.055-.723l-.082-.08.064-.096.443-.66a.594.594 0 01.2-.186.534.534 0 01.27-.074c.114 0 .23.038.347.111.098.061.21.133.335.215.12.08.257.159.412.238.11.056.235.102.377.137l.199-2.348a9.127 9.127 0 01-.721-.246 2.88 2.88 0 01-.765-.44 2.08 2.08 0 01-.558-.703c-.143-.286-.213-.638-.213-1.055a2.447 2.447 0 01.735-1.723 2.86 2.86 0 01.874-.578 3.24 3.24 0 011.064-.25l.053-.616a.547.547 0 01.154-.335.497.497 0 01.375-.154h.681zm-.54 6.454l-.169 2.013c.297-.063.523-.18.681-.347.186-.197.28-.455.28-.784a.764.764 0 00-.065-.329.789.789 0 00-.19-.25 1.295 1.295 0 00-.302-.201 3.122 3.122 0 00-.236-.102zm-.853-3.825c-.13.025-.243.059-.34.1a1.078 1.078 0 00-.331.21.731.731 0 00-.18.262.86.86 0 00-.057.315c0 .129.021.24.063.334a.814.814 0 00.182.257c.082.08.18.15.294.213.069.037.142.073.219.107l.15-1.798z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.564 25.264c-2.43 9.026-12.105 15.769-23.669 15.769S3.658 34.29 1.227 25.265c2.432 2.444 12.105 4.27 23.668 4.27 11.44 0 21.03-1.787 23.588-4.192l.08-.079z",
  stroke: "#371447",
  fill: "#6D4C41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.185 24.236c.149-.629-1.277-.842-4.278-.64-.329.52-.589 1.748-.78 3.684 1.374-.555 2.431-.934 3.174-1.135.742-.202 1.37-.838 1.884-1.91z",
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.298 32.423c7.074.63 12.244 1.328 15.508 2.092 3.264.764 7.846 2.35 13.745 4.755",
  stroke: "#371447",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.542 29.079c-4.577 1.019-8.369 2.268-11.376 3.749-3.006 1.48-6.026 3.516-9.06 6.106",
  stroke: "#371447",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.355 29.464c3.232 1.8 6.125 3.115 8.68 3.945 2.554.83 5.97 1.565 10.25 2.205",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.633 24.308c-.149-.629 1.278-.842 4.278-.64.329.52.589 1.748.78 3.684-1.373-.555-2.431-.934-3.173-1.135-.743-.202-1.371-.838-1.885-1.909z",
  fill: "#371447"
}));

function SvgRetirementMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRetirementMd;